import React, { useContext, useEffect, useState } from "react";
import { Handle, Position } from "reactflow";
import {
  Avatar,
  Typography,
  IconButton,
  Paper,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PersonIcon from "@mui/icons-material/Person";
import "./OrgPage.scss";
import {
  DeleteStake,
  GetStakeDetail,
  GetStakeList,
} from "../../service/StakeService";
import { useParams } from "react-router-dom";
import { PreferencesContext } from "../../PreferenceContext";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "../../assets/images/closeIcon.png";
import { AlertType } from "../../shared/AlertType";
import GroupIcon from "@mui/icons-material/Group";
import StakeHoldersDetail from "../StakeHoldersDetail";
import AddStakeHolderDialog from "../AddStakeHolder";
import AddNoteDialog from "../AddNotes";
import Editicon from "../../assets/images/editicon.png";
import Detailicon from "../../assets/images/detailicon.png";
import NoteIcon from "../../assets/images/note.png";
import editProfileIcon from "../../assets/images/editprofile.png";
import zoomIcon from "../../assets/images/zoomIcon.png";
import moreIcon from "../../assets/images/moreIcon.png";
import DuplicateIcon from "../../assets/images/duplicateIcon.png";
import DeleteImage from "../../assets/images/deleteIcon.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditStakeIcon from "../../assets/images/editStakeIcon.png";
import { UpdateParentStackDelete } from "../../service/StakeRelationService";

const StakeholderNode = ({ data }: any) => {
  let initStackHolder = {
    firstName: "",
    lastName: "",
    company: "",
    role: "",
    teamName: "",
    contact: "",
    temperature: "",
    temperaturecolour: "",
    notes: "",
    nodecolour: "",
    UID: 0,
    profileImage: "",
  };
  const [stakeholderDetail, setStakeholderDetail] = useState(initStackHolder);
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [title, setTitle] = useState("Untitled Stake");
  const [stakeList, setStakeList] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedStakeholder, setSelectedStakeholder] = useState<any>(null);
  const [temperatureTypeColl, setTemperatureTypeColl] = useState<any[]>([]);
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const urlToken = tokenFromParams;
  const isOwner = !urlToken || urlToken === userContext?.localToken;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteStakeId, setDeleteStakeId] = useState<any>(null);
  const [addNotesPopup, setAddNotesPopup] = useState<any>({
    open: false,
    stakeId: null,
  });
  const [addStackHolderPopup, setAddStackHolderPopup] = useState<any>({
    open: false,
    stakeId: null,
    uid: null,
  });
  const [historyAndDetailsPopup, setHistoryAndDetailsPopup] = useState<any>({
    open: false,
    stake: null,
  });
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);

    const raw = e.dataTransfer.getData("application/stakeholder");
    if (raw) {
      try {
        const draggedData = JSON.parse(raw);
        const sourceUID = draggedData.id;
        const targetUID = data.UID;
        // if (data?.onDropConnect && sourceUID !== targetUID) {
        //     data.onDropConnect(targetUID, sourceUID);
        // }
      } catch (err) {
        console.error("Error parsing dropped data:", err);
      }
    }
  };

  const handleOpenAddNotesPopup = (stakeId: any) => {
    setAddNotesPopup({ open: true, stakeId });
  };
  const handleOpenEditStackHolderPopup = (uid: any) => {
    setAddStackHolderPopup({ open: true, uid });
  };
  const closeAddStakeHolderPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await fetchStakList();
      getStakeDetail(data.UID);
    }
    setAddStackHolderPopup({ open: false, uid: null });
  };
  const closeNotesPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await fetchStakList();
    }

    setAddNotesPopup({ open: false, stakeId: null });
  };

  const handleOpenHistoryAndDetailsPopup = (stake: any) => {
    setHistoryAndDetailsPopup({ open: true, stake });
  };

  const closeHistoryAndDetailsPopup = () => {
    setHistoryAndDetailsPopup({ open: false, stake: null });
    fetchStakList();
    getStakeDetail(data.UID);
  };
  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    stake: any
  ) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedStakeholder(stake);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedStakeholder(null);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteStakeId(null);
  };
  const fetchStakList = async () => {
    try {
      const params = new URLSearchParams();
      params.append("token", token || "");
      const response: any = await GetStakeList(params);
      if (response?.data?.data?.stakeColl) {
        setStakeList(response.data?.data?.stakeColl);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
  };

  const getStakeDetail = async (UID: number) => {
    try {
      const response: any = await GetStakeDetail({ UID });
      if (response?.data?.data) {
        const data = response.data.data;
        const mappedStakeDetailData = {
          UID: parseInt(data.UID),
          firstName: data.FIRST_NAME || "",
          lastName: data.LAST_NAME || "",
          company: data.ORG_NAME || "",
          role: data.ROLE_NAME || "",
          teamName: data.TEAM_NAME || "",
          contact: data.CONTACT_DETAIL || "",
          temperature: data.TEMPERATURE_TYPE || "",
          temperaturecolour: data.TEMPERATURE_COLOUR_CODE || "",
          nodecolour: data.COLOUR_HASH_CODE || "",
          notes: data.INITIAL_NOTE || "",
          profileImage: data.PROFILE_IMAGE_BASE64 || "",
        };

        setStakeholderDetail(mappedStakeDetailData);
        return mappedStakeDetailData;
      } else {
        console.log("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching stakeholder detail:", error);
    }
  };

  const handleDetachStakeholder = async (UID: number) => {
    try {
      // Set PARENT_STAKE_ID to null
      await UpdateParentStackDelete(UID, null, userContext?.UID);

      // updateUserContext({
      //   ...userContext,
      //   isAlert: true,
      //   alertMessage: "Stakeholder detached from parent successfully.",
      //   alertType: AlertType.Success,
      // });

      setOpenDeleteModal(false);
      setDeleteStakeId(null);

      if (historyAndDetailsPopup.open) closeHistoryAndDetailsPopup();

      if (data?.refreshStakeList) {
        data.refreshStakeList();
      }
    } catch (error: any) {
      console.error("Error detaching stakeholder:", error);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error?.message || "Something went wrong!",
        alertType: AlertType.Error,
      });
    }
  };

  const handleDeleteStake = (UID: any) => {
    setDeleteStakeId(UID);
    setOpenDeleteModal(true);
  };
  const handleConfirmDeleteStake = async () => {
    try {
      await DeleteStake(deleteStakeId);

      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Stakeholder deleted successfully.",
        alertType: AlertType.Success,
      });

      setOpenDeleteModal(false);
      setDeleteStakeId(null);

      if (historyAndDetailsPopup.open) closeHistoryAndDetailsPopup();

      fetchStakList();
    } catch (error: any) {
      console.error("Error deleting stakeholder:", error);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error?.message || "Something went wrong!",
        alertType: AlertType.Error,
      });
    }
  };
  useEffect(() => {
    if (data.UID > 0) getStakeDetail(data.UID);
    else setStakeholderDetail({ ...initStackHolder });
    fetchStakList();
  }, [data.UID]);
  useEffect(() => {
    if (token) {
      fetchStakList();
    }
  }, [token]);
  return (
    <Box>
      <Box className="orgpage-grid-container">
        {/* <Paper className="orgpage-stakeholder-paper">  */}
        <Paper
          className={`stakeholder-node-paper ${
            isDragOver ? "highlight-drop" : ""
          }`}
          // sx={{ backgroundColor: stakeholderDetail?.nodecolour }}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <Handle
            type="target"
            position={Position.Top}
            style={{
              background: "#555",
              width: 7,
              height: 7,
              borderRadius: "50%",
              top: -5,
              left: "55%",
              transform: "translateX(-50%)",
            }}
          />
          <Handle
            type="source"
            position={Position.Bottom}
            style={{
              background: "#555",
              width: 7,
              height: 7,
              borderRadius: "50%",
              bottom: -10,
              left: "55%",
              transform: "translateX(-50%)",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            width="100%"
            gap={1}
            className="stakeholder-hover-wrapper"
          >
            {/* Left IconButton */}
            <IconButton
              className="more-icon-btn"
              sx={{
                padding: "0 !important",
                minWidth: "0 !important",
                width: "auto !important",
                height: "auto !important",
                "& .MuiTouchRipple-root": { display: "none" },
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClick(e, stakeholderDetail);
              }}
            >
              <img
                src={moreIcon}
                alt="edit"
                style={{ width: 16, height: 16 }}
              />
            </IconButton>

            <Box
              className="stakeholderNode-box"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              minWidth="330px"
              sx={{ backgroundColor: "white" }}
              onClick={() => {
                handleOpenHistoryAndDetailsPopup(stakeholderDetail);
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  className="stakeholderNode-color-strip"
                  sx={{
                    backgroundColor: stakeholderDetail?.nodecolour || "#C8A2C8",
                  }}
                />
                <Avatar
                  src={stakeholderDetail?.profileImage || undefined}
                  className="stakeholderNode-avatar"
                  sx={{ marginLeft: "15px", border: "2px solid #E0E0E0" }}
                >
                  {stakeholderDetail?.profileImage && <PersonIcon />}
                </Avatar>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    // className="tabel-node-data"
                    sx={{
                      maxWidth: "190px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "rgba(35, 35, 35, 1) !important",
                    }}
                  >
                    {stakeholderDetail?.firstName} {stakeholderDetail?.lastName}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      maxWidth: "190px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "12px",
                      // paddingLeft: "7px",
                      color: "rgba(96, 96, 96, 1) !important",
                    }}
                  >
                    {stakeholderDetail?.role}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      maxWidth: "190px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "12px",
                      // paddingLeft: "7px",
                      color: "rgba(96, 96, 96, 1) !important",
                    }}
                  >
                    {stakeholderDetail?.teamName}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      maxWidth: "190px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "12px",
                      // paddingLeft: "7px",
                      color: "rgba(96, 96, 96, 1) !important",
                    }}
                  >
                    {stakeholderDetail?.company}
                  </Typography>
                </Box>
                {stakeholderDetail?.temperaturecolour && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "6px",
                      right: "6px",
                      width: "14px",
                      height: "14px",
                      borderRadius: "50%",
                      backgroundColor: stakeholderDetail.temperaturecolour,
                      margin: "10px 10px 0  0 ",
                    }}
                  />
                )}
              </Box>

              {isOwner && (
                <IconButton
                  className="zoom-icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleMenuClose();
                    handleOpenEditStackHolderPopup(stakeholderDetail?.UID);
                  }}
                  sx={{
                    backgroundColor: "transparent",
                    padding: "0 !important",
                    paddingRight: "8px !important",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  <img
                    src={zoomIcon}
                    alt="edit"
                    style={{ width: 16, height: 16 }}
                  />
                </IconButton>
              )}
            </Box>
          </Box>

          <Handle
            type="source"
            position={Position.Bottom}
            style={{
              visibility: "hidden",
              left: "55%",
              transform: "translateX(-50%)",
            }}
          />
        </Paper>
      </Box>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            minWidth: 180,
            p: 1,
          },
        }}
        MenuListProps={{
          sx: {
            p: 0,
          },
        }}
      >
        <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: 0,
            height: "28px",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleOpenHistoryAndDetailsPopup(selectedStakeholder);
          }}
        >
          <ListItemIcon>
            <VisibilityOutlinedIcon
              style={{
                width: 18,
                height: 18,
                marginLeft: "5px",
                color: "rgba(35, 35, 35, 1)",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Details"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem>

        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="edit-note-menu-item"
            sx={{
              paddingLeft: 0,
              padding: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleOpenEditStackHolderPopup(selectedStakeholder?.UID);
            }}
          >
            <ListItemIcon>
              <img
                src={EditStakeIcon}
                alt="note"
                style={{
                  width: 25,
                  height: 25,
                  color: "rgba(35, 35, 35, 1)",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Edit"
              className="popup-text"
              style={{ color: "rgba(35, 35, 35, 1)" }}
            />
          </MenuItem>
        )}
        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="delete-note-menu-item"
            sx={{
              paddingLeft: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingRight: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleDetachStakeholder(selectedStakeholder?.UID);
            }}
          >
            <ListItemIcon className="delete-list-item-icon">
              <img
                src={DeleteImage}
                alt="delete"
                style={{ paddingLeft: "5px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Remove From map"
              className="delete-text  popup-text"
              style={{ color: "rgba(104, 0, 1, 1)" }}
            />
          </MenuItem>
        )}
        {/* <MenuItem
          className="delete-menu-item"
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleDetachStakeholder(selectedStakeholder?.UID);
          }}
        >
          <ListItemIcon className="delete-list-item-icon">
            <DeleteIcon fontSize="small" className="delete-icon" />
          </ListItemIcon>
          <ListItemText primary="Remove From tree" className="delete-text" />
        </MenuItem> */}
      </Menu>
      <Dialog
        open={historyAndDetailsPopup.open}
        onClose={closeHistoryAndDetailsPopup}
        fullWidth={false}
        maxWidth={false}
        PaperProps={{
          sx: {
            // padding: "30px",
            margin: 0,
            width: "1100px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "30px 30px 16px 30px ",
          }}
        >
          <Avatar sx={{ mr: 2 }}>
            <img
              src={editProfileIcon}
              alt="Edit profile"
              style={{ width: "42px", height: "42px" }}
            />
          </Avatar>
          <Typography className="edit-popup-title">
            Stakeholder Details
          </Typography>

          <IconButton
            onClick={closeHistoryAndDetailsPopup}
            sx={{
              ml: "auto",
              padding: "0 !important",
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "transparent !important",
              },
            }}
          >
            <img
              src={CloseIcon}
              alt="Close"
              style={{ width: 24, height: 24 }}
            />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ mx: 4 }} />
        <DialogContent
          dividers
          sx={{
            px: 3,
            py: 2,
            padding: "10px 0px 0px 0px",
            borderBottom: "none",
          }}
        >
          <StakeHoldersDetail
            stackholder={historyAndDetailsPopup.stake}
            handleDeleteStack={(UID: string) => {
              handleDeleteStake(UID);
            }}
          />
        </DialogContent>
      </Dialog>
      <AddNoteDialog
        UID={0}
        STAKEUID={addNotesPopup?.stakeId || ""}
        open={addNotesPopup.open}
        onClose={() => setAddNotesPopup({ open: false, stakeId: null })}
      />
      <AddStakeHolderDialog
        open={addStackHolderPopup.open}
        onClose={closeAddStakeHolderPopup}
        UID={addStackHolderPopup?.uid || 0}
      />
      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete this stakeholder?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmDeleteStake}
            variant="contained"
            color="error"
          >
            Yes, Delete
          </Button>
          <Button
            onClick={handleCloseDeleteModal}
            variant="outlined"
            sx={{ backgroundColor: "#ffffff" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StakeholderNode;
